var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customizer-legacy-navigation"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFlyout,
      expression: "showFlyout"
    }],
    staticClass: "customizer-legacy-navigation-flyout",
    class: [{
      'customizer-legacy-navigation-flyout--external-header': _vm.externalHeadersVisible
    }]
  }, [_c('div', {
    staticClass: "customizer-legacy-navigation-flyout-close-btn",
    on: {
      "click": _vm.closeFlyout
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })]), _c('div', {
    staticClass: "customizer-legacy-navigation-flyout-steps"
  }, [_c('ul', {
    staticClass: "customizer-legacy-navigation-flyout-steps-list"
  }, _vm._l(_vm.menu, function (item) {
    return _c('li', {
      key: item.name,
      class: ['customizer-legacy-navigation-flyout-steps-item', item.name, {
        disabled: _vm.rayTracerDisabled
      }],
      on: {
        "click": function click($event) {
          return _vm.selectComponent(item.name, _vm.$customizerDataLayer.types.selectComponentMenu, true, item.display_name);
        }
      }
    }, [_c('span', {
      class: ['icon', item.item_state ? 'icon-check' : 'list-configurator-bullet']
    }), _c('span', {
      staticClass: "customizer-legacy-navigation-flyout-steps-item-name"
    }, [_vm._v(_vm._s(item.display_name))]), item.hasUGC && _vm.isUGCEnabled && _vm.noPaletteLockOrUniqueSwatches ? _c('span', {
      class: ['icon-camera customizer-legacy-navigation-flyout-steps-item-ugc', {
        disabled: _vm.areUGCIconsDisabled || _vm.rayTracerDisabled
      }, {
        hide: _vm.configuration.enableCollapsingSwatches && _vm.areUGCIconsDisabled
      }],
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.openUGC($event, item.name);
        }
      }
    }) : _vm._e(), item.hasPersonalization && _vm.isPersonalizationEnabled && _vm.noPaletteLockOrUniqueSwatches ? _c('span', {
      class: ['icon-edit customizer-legacy-navigation-flyout-steps-item-personalization', {
        disabled: _vm.isPersonalizationIconDisabled || _vm.rayTracerDisabled
      }, {
        hide: _vm.configuration.enableCollapsingSwatches && _vm.isPersonalizationIconDisabled
      }],
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.openPersonalization($event, item.name);
        }
      }
    }) : _vm._e()]);
  }), 0)]), _c('div', {
    class: ['customizer-legacy-navigation-flyout-start-over', {
      disabled: _vm.rayTracerDisabled
    }],
    on: {
      "click": _vm.startOver
    }
  }, [_c('span', {
    staticClass: "customizer-legacy-navigation-flyout-start-over-icon icon-redo"
  }), _vm._v("\n      " + _vm._s(_vm.translations.headerStartOver) + "\n    ")])]), _c('div', {
    class: ['customizer-legacy-navigation-main', this.themeMenu],
    style: _vm.themeMenuStyle
  }, [_c('div', {
    staticClass: "customizer-legacy-navigation-main-labels"
  }, [_c('p', {
    staticClass: "customizer-legacy-navigation-main-labels-numbers"
  }, [_vm._v("\n          " + _vm._s(_vm.currentComponentNumber) + " / " + _vm._s(_vm.visibleComponentsNumber) + "\n        ")]), this.menu[_vm.activeComponent] ? _c('h2', {
    staticClass: "customizer-legacy-navigation-main-labels-component-name"
  }, [_c('span', [_vm._v("\n            " + _vm._s(this.menu[_vm.activeComponent].display_name) + "\n          ")])]) : _vm._e()]), _c('div', {
    staticClass: "customizer-legacy-navigation-main-steps"
  }, [_c('div', {
    class: ['customizer-legacy-navigation-main-steps-open-flyout-button customizer-legacy-navigation-main-button', {
      disabled: _vm.rayTracerDisabled
    }],
    on: {
      "click": _vm.openCloseFlyout
    }
  }, [_c('span', {
    staticClass: "customizer-legacy-navigation-main-button-icon icon-menu"
  })]), _c('div', {
    class: ['customizer-legacy-navigation-main-steps-open-prev customizer-legacy-navigation-main-button', {
      disabled: _vm.rayTracerDisabled
    }],
    on: {
      "click": function click($event) {
        return _vm.changeComponent('previous');
      }
    }
  }, [_c('span', {
    staticClass: "customizer-legacy-navigation-main-button-icon icon-arrow-left-indicator"
  })]), _c('div', {
    class: ['customizer-legacy-navigation-main-steps-open-next customizer-legacy-navigation-main-button', {
      disabled: _vm.rayTracerDisabled
    }],
    on: {
      "click": function click($event) {
        return _vm.changeComponent();
      }
    }
  }, [_c('span', {
    staticClass: "customizer-legacy-navigation-main-button-icon icon-arrow-right-indicator"
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }